import {
  ISidebarState,
  SidebarStateObject,
} from '../model/sidebar-state.model';

export function createStateObject(state: ISidebarState): SidebarStateObject {
  return new SidebarStateObject(state);
}
